<template>
  <div style="width:100%;height:auto;">
      <el-carousel height="400px" style="position:relative;">
          <el-carousel-item v-for="(item, index) in sliders" :key="index">
              <div style="position:absolute;right:0;top:0;width:40%;"><img :src="item.path" class="slider_img" style="max-width:600px;max-height:400px;"></div>
              <div style="position:absolute;z-index:2;top:12%;left:5%;">
                <div style="font-size:48px;font-weight:bold;color:#022032;">{{ item.content01 }}</div>
                <div style="font-size:18px;color:#022032;margin:40px 0;">
                  <p>{{ item.content02 }}</p>
                  <p style="margin:15px 0;">{{ item.content03 }}</p>
                  <p>{{ item.content04 }}</p>
                </div>
                <a class="button a1" @click="goProduct">Learn more</a>
              </div>
          </el-carousel-item>
      </el-carousel>
      <div class="product_parent">
        <!-- <img :src="this.productHome.homeImagePath" style="position: absolute;top:0;left:0;width:100%;height:782px;">
        <div style="position: absolute;top:0;left:0;width:100%;height:auto;">
          <div class="p_1">{{ this.productHome.homeName }}</div>
          <div class="p_2">{{ this.productHome.homeDesc }}</div>
          <div class="p_3">{{ this.productHome.name }}</div>
          <div class="p_4">{{this.productHome.remark}}</div>
          <div class="p_5"><a class="button a1" @click="goProduct">Learn more</a></div>
        </div> -->
        <div style="width:100%;height:460px;position:relative;">
          <img :src="this.productHome.homeImagePath" style="position: absolute;top:260px;left:150px;z-index:2;width:594px;height:461px;">
          <div style="position: absolute;top:0;left:0;width:100%;height:auto;z-index:2;">
            <div class="p_1">{{ this.productHome.homeName }}</div>
            <div class="p_2">{{ this.productHome.homeDesc }}</div>
            <div class="p_3">{{ this.productHome.name }}</div>
          </div>
        </div>
        <div style="width:100%;height:325px;position:relative;">
          <img :src="this.productHome.homeBackGroundPath" style="position: absolute;top:0;left:0;width:100%;height:auto;">
          <div style="position: absolute;top:0;left:0;width:100%;z-index:2;">
            <div class="p_4">{{this.productHome.remark}}</div>
            <div class="p_5"><a class="button a1" @click="goProduct()">Learn more</a></div>
          </div>
        </div>
        
      </div>
      <!-- News&events -->
      <div class="news_parent">
          <div class="item" style="margin-right:30px">
             <div class="title">News</div>
             <ul>
              <li style="display:flex;justify-content: center;margin-bottom:36px" v-for="(item, index) in newsList" :key="index" @click="goNewsDetail(item)">
                <div class="img-sty">
                  <a class="img-hover"><img class="img-wh" :src="item.smallImage" /></a>
                </div>
                <div style="flex:1;padding-left:30px;">
                  <p style="font-size:20px;margin-bottom:20px;color:#000;"><a class="a1">{{ item.title }}</a></p>
                  <p style="font-size:16px;margin-bottom:14px;color:#878787;">{{ item.createTime ? item.createTime.split(' ')[0] : '' }}</p>
                  <p class="p3" style="font-size:16px;line-height:20px;color:#878787;">{{ item.remark }}</p>
                </div>
              </li>
             </ul>
             <div style="text-align: center;width:100%">
              <a class="button a1" @click="goNews">Learn More</a>
             </div>
          </div>
          <div class="item">
            <div class="title">Events</div>
            <ul>
              <li style="display:flex;align-items: center;justify-content: center; margin-bottom:36px" v-for="(item, index) in eventsList" :key="index" @click="goNewsDetail(item)">
                <div class="img-sty">
                  <a class="img-hover"><img class="img-wh" :src="item.smallImage" /></a>
                </div>
                <div style="flex:1;padding-left:30px;">
                  <p style="font-size:20px;margin-bottom:20px;color:#000;"><a class="a1">{{ item.title }}</a></p>
                  <p style="font-size:16px;margin-bottom:14px;color:#878787;">{{ item.createTime ? item.createTime.split(' ')[0] : '' }}</p>
                  <p class="p3" style="font-size:16px;line-height:20px;color:#878787;">{{ item.remark }}</p>
                </div>
              </li>
            </ul>
            <div style="text-align: center;width:100%">
              <a class="button a1" @click="goEvents">Learn More</a>
             </div>
          </div>
      </div>
      
  </div>
</template>
<script>
  import { bannerList, NewsEventsList, productHome } from '@/api/index' ;
  export default {
      name: 'Index',
      data() {
          return {
              sliders: [], // banner
              newsList: [],
              eventsList: [],
              carousel_height: '400px',
              productHome: {},
          }
      },
      methods: {
          goFruit() {
              this.$router.push({name: "Fashion"});
          },
          goNews() {
            this.$router.push({name: "Newsevents"});
          },
          goEvents() {
            this.$router.push({name: "Newsevents"});
          },
          // 获取banner
          getBannerList() {
              const params = {};
              bannerList(params).then((res) => {
                  // this.sliders = res;
                  res.forEach((item, index) => {
                    if (index == 0) {
                      item.content01 = 'lab-on-chip technology';
                      item.content02 = '"has the potential to revolutionize the way we diagnose and treat disease,';
                      item.content03 = 'by making complex lab-based procedures simple, fast, and portable."';
                      item.content04 = '-Richard Mathies, UC Berkeley';
                    }
                    if (index == 1) {
                      item.content01 = 'Beautiful and powerful';
                      item.content02 = '"Small is beautiful, and small is powerful."';
                      item.content03 = '- George Whitesides, Harvard University  ';
                      item.content04 = '';
                    }
                    if (index == 2) {
                      item.content01 = 'Our fate is in our genes';
                      item.content02 = '"We used to think our fate was in our stars. ';
                      item.content03 = 'Now we know, in large measure, our fate is in our genes."';
                      item.content04 = '- James D. Watson, Nobel Laureate';
                    }
                  })
                  this.sliders = res;
                  console.log(this.sliders, 'this.sliders');
              });
          },
          // 获取product home
          getProductHome() {
              const params = {};
              productHome(params).then((res) => {
                console.log(res, 'productHome');
                this.productHome = res;
              });
          },
          // 调转product详情
          goProduct() {
            this.$router.push({
              path: './Product',
              query: {
                id: this.productHome.id
              }
            });
          },
          // 获取News
          getNewsList() {
              const params = {
                type: 'News',
              };
              NewsEventsList(params).then((res) => {
                console.log(res, 'res news')
                  if (res.length >= 2) {
                    this.newsList = res.slice(0,3);
                  } else {
                    this.newsList = res;
                  }
                  console.log(this.newsList, 'this.newsList');
              });
          },
          // 获取Events
          getEventsList() {
              const params = {
                type: 'Events',
              };
              NewsEventsList(params).then((res) => {
                if (res.length >= 2) {
                    this.eventsList = res.slice(0,3);
                  } else {
                    this.eventsList = res;
                  }
                  console.log(this.eventsList, 'this.eventsList');
              });
          },
          // 新闻详情
          goNewsDetail(item) {
            console.log(item, 'items');
            this.$router.push({
              path: './Newsdetail',
              query: {
                id: item.id
              }
            });
          },
      },
      mounted() {
        this.getBannerList();
        this.getProductHome();
        this.getNewsList();
        this.getEventsList();
      },
      computed: {
          //计算高度
          computeHeight() {
              let screenHeight = document.body.clientWidth;
              if (screenHeight > 415) {
                  return '400px';
              } else {
                  return '200px';
              }
          },
          computeArrowImg() {
              let screenHeight = document.body.clientWidth;
              if (screenHeight > 450) {
                  return require('../../static/other/arrow.png');
              } else {
                  return require('../../static/other/arrow_down.png');
              }
          }

      },
  }
</script>

<style scoped>

  .slider_img {
      /* height: 400px; */
      width: 100%;
      cursor: pointer;
      height:auto;
  }
  ::v-deep .el-carousel__button {
      width: 13px !important;
      height: 13px !important;
      border: 1px solid #acacac !important;
      border-radius: 50% !important;
      background-color: #acacac !important;
      opacity: none !important;
  }
  ::v-deep .el-carousel__indicator.is-active button {
      background-color: #00718c !important;
      border: 1px solid #00718c !important;
      opacity: none !important;
  }
  .p3 {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
  }
  .button {
    /* width:176px; */
    height:50px;
    background: #00718c;
    text-align: center;
    line-height:50px;
    color:#fff;
    border-radius:25px;
    font-size: 20px;
    cursor: pointer;
    padding: 0px 34px;
    display:inline-block;
    /* box-shadow: 0 0 2px #00718c; */
  }
/* 首页产品 */
  .product_parent {
    width: 100%;
    height: 782px;
    text-align: center;
    /* background-image: url('http://localhost/pic/banner/13b71b98-dc1f-4e4e-b9c7-dcaee911802c.png'); */
    /* background-image: url('../assets/product_banner.png'); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    /* padding-top:97px; */
  }
  .product_parent .p_1 {
    width: 100%;
    font-size:36px;
    font-weight: bold;
    /* height:53px; */
    line-height:53px;
    /* margin: 97px auto 0; */
    padding-top:95px;
    /* font-family: Arial Black; */
    font-family: Arial;
    color:#022032;
  }
  .product_parent .p_2 {
    text-align: center;
    width: 612px;
    font-size:16px;
    /* margin: 24px auto 0; */
    line-height: 25px;
    margin:auto;
    color:#022032;
  }
  .product_parent .p_3 {
    margin:180px 0 0 0px;
    /* margin-left:50%; */
    margin-left:64%;
    font-size: 72px;
    font-weight: bold;
    text-align:left;
    line-height: 65px;
    font-size:40px;
    /* font-family:'[HelveticaNeue]'; */
    /* font-family: Arial Black; */
    font-family: Arial;
    color:#022032;
  } 
  .product_parent .p_4 {
    margin-top: 35px;
    font-size: 18px;
    text-align:left;
    line-height: 31px;
    color: #fff;
    float:right;
    /* margin-left:50%; */
    margin-left:64%;
    margin-right:116px;
    margin-bottom: 35px;
    color:#f5f5f5;
  } 
  .product_parent .p_5 {
    /* margin-top: 35px; */
    text-align:left;
    /* margin-left:50%; */
    margin-left:64%;
  }
  /* 首页news&events */
  .news_parent {
    display:flex;
    /* width: 85%; */
    margin: 115px 139px 140px 139px;
    align-items: center;
    height: auto;
    /* justify-content: space-between; */
  }
  .news_parent .item {
    /* width: 40%; */
    /* margin: 0 132px; */
    height: auto;
    border-radius:20px;
    background-color:#f5f5f5;
    padding: 53px 40px 38px 27px;
    flex: 1;
  }
  .news_parent .item .title {
    text-align:center;
    font-size:30px;
    color:#022032;
    /* font-weight:bold; */
    margin-bottom:47px;
    /* font-family: Arial Black; */
    font-family: Arial;
  }

  .img-sty {
    width:143px;
    height:143px;
    overflow: hidden;
    max-width:141px;
    max-height:141px;
  }
  .img-hover {
    object-fit: cover;
    transition: all 2s;
    overflow:hidden;
  }
  .img-hover :hover {
	/* 放大1.3倍 */
    transform: scale(1.2);
  }
  .img-wh {
    width:100%;
    height:auto;
    max-height:141px;
    max-width:100%;
  }
  ::v-deep .el-carousel__container {
    height:auto;
  }
  ::v-deep .el-carousel__indicators {
    bottom:10px;
  }
</style>